import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import '../src/assets/styles/theme.scss';
import { ThemedToastContainer } from './layouts/ThemedToastContainer';
import { UserPermissionsProvider } from './contexts/UserPermissionsContext';
import { DirtyProvider } from './contexts/DirtyContext';
import { ConfirmProvider } from './contexts/ConfirmContext';
import ErrorBoundary from './components/ErrorBoundary';
import { installClientErrorLogging } from './utils/logShipper';

// Catch uncaught exceptions and unhandled rejections from here on, and ship
// them to System → Web Error Logs. Installed before render so a crash during
// the first paint is still captured.
installClientErrorLogging();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <UserPermissionsProvider>
        <BrowserRouter>
        {/* ConfirmProvider sits ABOVE DirtyProvider so the dirty-navigation
            guards can use the themed confirm dialog — native window.confirm
            is suppressed by several mobile browsers, which silently blocked
            navigation away from dirty forms on phones. */}
        <ConfirmProvider>
        <DirtyProvider>
          <App />
        </DirtyProvider>
        </ConfirmProvider>
          <ThemedToastContainer />
        </BrowserRouter>
    </UserPermissionsProvider>
  </ErrorBoundary>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
